import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69fa07d2f6558f00149cf805_1782989597070_c095ac17/neetnavigator/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69fa07d2f6558f00149cf805_1782989597070_c095ac17/neetnavigator/src/components/Sidebar.tsx");
